module.exports = __webpack_public_path__ + "static/img/girl.7b901208.jpg";